import type { ServiceScope } from '@vnetwork/margarita-shell/service-route';
import { aes } from './register-aes';
import { compute } from './register-compute';
import { eagle } from './register-eagle';
import { database } from './register-database';
import { fastchannel } from './register-fastchannel';
import { hosting } from './register-hosting';
import { kubernetes } from './register-kubernetes';
import { live } from './register-live';
import { mail } from './register-mail';
import { oss } from './register-oss';
import { raven } from './register-raven';
import { vod } from './register-vod';
import { waap } from './register-waap';
import { waf } from './register-waf';

/**
 * The provider scopes the service catalog knows a module for, merged from each module's
 * `service.ts` (`serviceScopes`): the category a provisioned service falls under and where it
 * opens. `src/lib/service-categories.ts` reads this through `@/lib/service-scopes`; the taxonomy
 * (category order, group titles, icons) stays in the shell. To add a module: export
 * `serviceScopes` from its `service.ts` and add one line here. A scope appears once.
 *
 * The modules export plain `as const` data and import nothing shared (the host-contract ratchet);
 * the typed array below is what checks their shape, so a mistyped category or scope field fails
 * `tsc` here.
 */
export const SERVICE_SCOPES: readonly ServiceScope[] = [
  ...aes.serviceScopes,
  ...compute.serviceScopes,
  ...database.serviceScopes,
  ...eagle.serviceScopes,
  ...fastchannel.serviceScopes,
  ...hosting.serviceScopes,
  ...kubernetes.serviceScopes,
  ...live.serviceScopes,
  ...mail.serviceScopes,
  ...oss.serviceScopes,
  ...raven.serviceScopes,
  ...vod.serviceScopes,
  ...waap.serviceScopes,
  ...waf.serviceScopes,
];
